import InputBase from "./InputBase";
import { twMerge } from "tailwind-merge";

type InputProps = {
  type: 'text' | 'tel' | 'date' | 'email';
  label: string;
  placeholder: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  error?: string;
  icon?: React.ReactNode | null;
  helperText?: string;
  required: boolean;
  inputClassName?: string;
  disabled?: boolean;
}

const Input = ({
  type,
  label,
  placeholder,
  value,
  onChange,
  error = '',
  icon = null,
  helperText = '',
  required,
  inputClassName = '',
  disabled = false
}: InputProps) => {
  return (
    <InputBase label={label} required={required} icon={icon} helperText={helperText} error={error}>
      <div className="relative">
        <input
          id={`${label}-input`}
          required={required}
          type={type}
          value={value}
          onChange={onChange}
          className={twMerge(`w-full px-4 py-3 border rounded-lg focus:outline-none focus:ring-2 transition-all ${
            error
              ? 'border-red-500 focus:ring-red-500 focus:border-red-500'
              : 'border-gray-300 focus:ring-brand-500 focus:border-brand-500'
          }`, inputClassName)}
          placeholder={placeholder}
          disabled={disabled}
        />
      </div>
    </InputBase>
  );
};

export default Input;
